import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { IvCertCircuitDocumentP, OperationService, WidgetOperation } from '../../../api';
import { FinishProService } from '../../services/finish-pro.service';
import { DocumentListObserve } from '../../models/operations/document-list-observe';
import { TranslateService } from '../../../core/translation/translate.service';
import { ActivatedRoute, Router } from '@angular/router';
import { operationTypeEnum } from '../../../models/operation-type';
import { DialogDeclineSignComponent } from '../../../shared/dialog/signaturit/dialog-decline-sign/dialog-decline-sign.component';
import { MessageService } from '../../../shared/message/message.service';
import { LanguageService } from '../../services/language.service';
import { AdvancedGenericOption, AuxiliarOption } from '../../../shared/types/signaturit/shared-types';
import { BehaviorSubject } from 'rxjs';
import { AvailableOperationStatus } from '../../models/operations/available-operation-status';
import { PersonalizationsService } from '../../../base/services/personalizations/personalizations.service';
import { DialogInternalMessage } from '../../../finish/dialog/internal-message/dialog-internal-message.component';
import { ProfileService } from '../../../core/profile/profile.service';
import { IvCertGenericResponseOperationDetailR } from '../../../api/model/ivCertGenericResponseOperationDetailR';
import { Extension, UploadConfig } from '../../../models/types';
import { Utils } from '../../../shared/utils/utils';
import { HelpModalComponent } from '../modal/help-modal/help-modal.component';

@Component({
  selector: 'app-documents-header',
  templateUrl: './documents-header.component.html',
  styleUrls: ['./documents-header.component.scss'],
  exportAs: 'documentsHeader'
})
export class DocumentsHeaderComponent implements OnInit, AfterViewInit {

  @Input() disableActions: boolean = false;

  @Output('selectedDoc') selectedDoc: EventEmitter<string> = new EventEmitter<string>();

  @Input() documents: IvCertCircuitDocumentP[];

  isSidebarOpen: boolean = false;

  totalDocuments: number = 0;

  extraDocuments: IvCertCircuitDocumentP[];

  hasExtra: boolean = false;

  creatorName: string;

  creatorEmail: string;

  fill_in_6: string;

  showLanguageSelector: BehaviorSubject<boolean>;

  mainDocs: IvCertCircuitDocumentP[];

  documentLabel: string;

  _transParam: boolean = false;

  kebabMenuOptions = [{ key: 'kebabDownloadDoc', value: this._translate.instant('signaturit_pro.downloadModal.title') }];

  internalMessages: boolean = false;

  messages: object[] = [];

  ownerId: number;

  receiverId: string;

  docSizeTotal: number = 0;

  maxFileSize: number = 0;

  fileConfig: UploadConfig;

  extensions: Extension;

  uploadedDocAdjuntos: IvCertCircuitDocumentP[] = [];

  docsUploadedTitle: string[] = [];

  letAttachment: boolean = false;

  customMessage: string;

  operationType: string;

  widgetOperation: WidgetOperation[] = [];

  helperFinishOp: boolean = false;

  selectedDocumentId: string = '';

  setSelectedDoc: string = '';

  constructor(
    private _router: Router,
    private _finishProService: FinishProService,
    private _dialog: MatDialog,
    private _translate: TranslateService,
    private _route: ActivatedRoute,
    private _message: MessageService,
    private _personalization: PersonalizationsService,
    private _operation: OperationService,
    private _profile: ProfileService,
    private _languageService: LanguageService) { }

  ngOnInit(): void {
    this.totalDocuments = this._finishProService.mainDocs?.filter(elem => elem['status'] !== AvailableOperationStatus.FINALIZADA).length;
    this.mainDocs = this._finishProService.mainDocs?.filter(elem => elem['status'] !== AvailableOperationStatus.FINALIZADA);
    this.documentLabel = `${this._translate.instant('detallecircuito_title_docs')} (${this.totalDocuments})`;
    this.internalMessages = this._personalization.sendEnv.features?.internalMessages;
    this.helperFinishOp = this._personalization.sendEnv.features?.helperFinishOp || false;
    this.docSizeTotal = this._finishProService.fileConfig.sizeTotal;
    this.maxFileSize = this._finishProService.fileConfig.sizeDoc;
    this.fileConfig = this._finishProService.fileConfig;
    this.extensions = this._finishProService.extensions;
    this.operationType = this._finishProService.operationDetailResponse?.operationType;
    this.widgetOperation = this._finishProService.operationDetailResponse?.widgetOperation;
    this.selectedDocumentId = this.mainDocs?.length ? this.mainDocs[0]?.idDocument : '';
    this.selectedDoc.emit(this.selectedDocumentId);
    this.letAttachment = this._finishProService.letAttachment;
    this.customMessage = this._finishProService.customMessage;
    if (this.internalMessages) {
      this.messages = this._finishProService.internalMessages;
      this.ownerId = this._finishProService.ownerId;
      this.receiverId = this._finishProService.receiverId;
    }
    this.getUploadedTitle();
    this.getCreatorInfo();
    this.getText();
  }

  ngAfterViewInit(): void {
    this.showLanguageSelector = this._languageService.showLanguageSelector;
  }

  getText(): void {
    const operationType: string = this._finishProService.getOperationType();
    if (operationType === operationTypeEnum.DWN) {
      this.fill_in_6 = this._translate.instant('signaturit_pro.document.fill_in_6b');
    } else {
      this.fill_in_6 = this._translate.instant('signaturit_pro.document.fill_in_6');
    }
  }

  setDocuments(): void {
    this.hasExtra = false;
    this.extraDocuments = this._finishProService.documentListResponse.filter(doc => doc.type === 2);
    if (this.extraDocuments.length > 0) this.hasExtra = true;
  }

  showKebab(index: string): void {
    document.getElementById('kebab_' + index).style.opacity = '1';
    document.getElementById('kebab_' + index).style.visibility = 'visible';
  }

  hideKebab(index: string): void {
    document.getElementById('kebab_' + index).style.opacity = '0';
    document.getElementById('kebab_' + index).style.visibility = 'hidden';
  }

  showKebabExtra(index: string): void {
    document.getElementById('kebabExtra_' + index).style.opacity = '1';
    document.getElementById('kebabExtra_' + index).style.visibility = 'visible';
  }

  hideKebabExtra(index: string): void {
    document.getElementById('kebabExtra_' + index).style.opacity = '0';
    document.getElementById('kebabExtra_' + index).style.visibility = 'hidden';
  }

  onclickKebab(event: AuxiliarOption, index: number, extra: boolean): void {
    switch (event.action) {
      case 'kebabDownloadDoc':
        if (!extra) this.downloadDocument(this.documents[index], index);
        else {
          this._finishProService.setExtraDocs();
          this.downloadDocument(this.extraDocuments[index], index, extra);
        }
        break;
    }
  }

  async downloadDocument(doc: IvCertCircuitDocumentP, index?: number, extra?: boolean): Promise<void> {
    try {
      await this._finishProService.getDownloadDocumentCircuit(DocumentListObserve.RESPONSE, doc.idDocument, true, false, index, extra);

      setTimeout(() => {
        if (this._finishProService.operationDetailResponse.operationType === operationTypeEnum.DWN && !extra) {
          this.validatorDocuments(doc);
        }
      }, 1000);
    } catch (e) {
      this._message.showError(e);
    }
  }

  async downloadDocuments(typeDoc: number): Promise<void> {
    try {
      await this._finishProService.getDownloadDocumentsCircuit(typeDoc);

      setTimeout(() => {
        if (this._finishProService.operationDetailResponse.operationType === operationTypeEnum.DWN && typeDoc !== 2) {
          this.documents.forEach(doc => {
            this.validatorDocuments(doc);
          })
        }
      }, 1000);
    } catch (e) {
      this._message.showError(e);
    }
  }

  async validatorDocuments(doc: IvCertCircuitDocumentP): Promise<void> {
    if (!this._finishProService.validatorDocumentList.includes(doc)) {
      this._finishProService.validatorDocumentList.push(doc);
    }

    const metadata: AdvancedGenericOption<boolean>[] = [{ key: "privacyPolicyAccepted", value: true }];

    try {
      if (this._finishProService.validatorDocumentList.length === this.documents.length) {
        await this._finishProService.putFinishOperation(true, metadata);
        try {
          const { operationId } = this._finishProService;
          const hasNextOperation = !!operationId;
          if (hasNextOperation) {
            this._finishProService.operationRequest.hasFinishCircuit = true;
            this._finishProService.operationRequest.idDocument = null;
            this._finishProService.operationRequest.documentList = null;
            this._finishProService.documentsReaded = [];
          }
          const route = this._finishProService.getRoutePath();
          const path = hasNextOperation ? `../${operationId}/${route}` : route;
          const CUSTOM_TIMEOUT: number = 500;
          setTimeout(() => this._router.navigate([path], { relativeTo: this._route.parent }), CUSTOM_TIMEOUT);
        }
        catch (e) {
          console.log(e);
        }
      }
    }
    catch (e) {
      console.log(e);
    }
  }

  getCreatorInfo(): void {
    this.creatorName = this._finishProService.operationDetailResponse?.userCreatorName;
    this.creatorEmail = this._finishProService.operationDetailResponse?.userCreatorEmail;
  }

  copyClip(): void {
    navigator.clipboard.writeText(this.creatorEmail);
  }

  openSidebar(): void {
    this.setDocuments();
    this.isSidebarOpen = true;
  }

  closeSidebar(): void {
    this.isSidebarOpen = false;
  }

  async closeSign(): Promise<void> {
    const dialog = this._dialog.open(DialogDeclineSignComponent, {
      width: '480px',
      data: { operationType: this.operationType, RejectionReasons: this._finishProService.operationDetailResponse?.RejectionReasons }
    });

    dialog.componentInstance.closeDialog.subscribe(() => {
      dialog.close();
    });

    dialog.componentInstance.cancelSign.subscribe(async response => {
      const metadata: AdvancedGenericOption<string | boolean>[] = [
        { key: 'rejectionReasonId', value: response.reasonId ? response.reasonId.toString() : null },
        { key: 'observations', value: response.observations },
        { key: "privacyPolicyAccepted", value: true }
      ];
      dialog.componentInstance.isLoading = true;

      await this._finishProService.putFinishOperation(true, metadata, false);
      try {
        const { operationId } = this._finishProService;
        const hasNextOperation = !!operationId;
        const route = this._finishProService.getRoutePath();
        const path = hasNextOperation ? `../${operationId}/${route}` : route;
        const CUSTOM_TIMEOUT: number = 500;
        dialog.close();
        setTimeout(() => this._router.navigate([path], { relativeTo: this._route.parent }), CUSTOM_TIMEOUT);
      } catch (e) {
        dialog.componentInstance.isLoading = false;
      }
    })
  }

  onDocumentSelect(document: IvCertCircuitDocumentP): void {
    const doc = this.documents.find(res => res.idDocument === document.idDocument);
    this.setSelectedDoc = doc.idDocument;
    this.selectedDoc.emit(this.setSelectedDoc);
    this.selectedDocumentId = document.idDocument;
    this._router.navigate([`document/${document.idDocument}`], { relativeTo: this._route.parent });
  }

  async refreshMessages(id: string) {
    this._operation.operationGetOperationDetail(id, this._profile.getPublicToken()).then(
      (response: IvCertGenericResponseOperationDetailR) => {
        const res = response.data;
        this.messages = res.messages;
      }, () => {
        this._message.showError(this._translate.instant('internal_message_error_message'));
      });
  }

  openDialog(): void {
    const dialogRef = this._dialog.open(DialogInternalMessage, {
      width: '30rem',
      data: {}
    });

    dialogRef.componentInstance.finish.subscribe((result) => {
      const operationId = this._finishProService.operationId
      this._operation.operationSendInternalMessage(operationId, result.result, this._profile.getPublicToken())
        .subscribe(() => {
          this._message.show(this._translate.instant('internal_message_success_message'), 'success', this._translate.instant('internal_message_success_message'));
          this.refreshMessages(operationId);
        }, () => {
          this._message.showError(this._translate.instant('internal_message_error_message'));
        });
      dialogRef.close();
    });
  }

  onUploadDoc(event): void {
    const upload = this.uploadedDocAdjuntos;
    this._finishProService.setAttachedDocs(this.uploadedDocAdjuntos);
    for (let i = 0; i < event.files.length; i++) {
      const file = event.files[i];
      const extension: string = file.name.split('.').pop();

      const blob = Utils.blobIE(file, 'application/pdf;charset=utf-8', extension.toLowerCase());
      const reader: FileReader = new FileReader();
      reader.readAsDataURL(blob);

      reader.onloadend = () => {
        const r = (reader.result as string).split(',')[1];
        upload.push({ fileNameWithExtension: file.name.replace(extension, extension.toLowerCase()), content: r, title: file.name.replace(`.${extension}`, ''), type: 2 });
        this._finishProService.setAttachedDocs(this.uploadedDocAdjuntos);
      };
    }
  }

  onClearDoc(): void {
    const uploaded = this.uploadedDocAdjuntos;
    uploaded.length = 0;
    this._finishProService.setAttachedDocs(this.uploadedDocAdjuntos);
  }

  onRemoveDoc(event): void {
    const uploaded = this.uploadedDocAdjuntos;
    for (let index = 0; index < uploaded.length; index++) {
      if (uploaded[index].fileNameWithExtension === event.files[0].name) {
        if (uploaded.length === 1) {
          uploaded.length = 0;
        } else {
          uploaded.splice(index, 1);
        }
      }
    }
    this._finishProService.setAttachedDocs(this.uploadedDocAdjuntos);
  }

  getUploadedTitle(): void {
    this._finishProService.documentListResponse?.forEach(doc => {
      this.docsUploadedTitle.push(doc.fileNameWithExtension);
    })
  }

  showHelpModal(): void {
    this._dialog.open(HelpModalComponent, {
      width: '600px',
    })
  }

}
